import React from 'react';
import { Box, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import MoreHoriz from '@mui/icons-material/MoreHoriz';

const useStyles = makeStyles((theme: Theme) => ({
  '@keyframes slideInFromRight': {
    '0%': {
      transform: 'translateX(100px)',
      opacity: 0,
    },
    '100%': {
      transform: 'translateX(0)',
      opacity: 1,
    },
  },
  buttonContainer: {
    alignItems: 'center',
    borderRadius: theme.spacing(1.5),
    display: 'flex',
    height: theme.spacing(5.75),
    justifyContent: 'center',
    width: theme.spacing(5.75),
    cursor: 'pointer',
    backgroundColor: theme.palette.background.paper,
    boxShadow: '0px 4px 8px var(--shadow-light)',
    '&:hover': {
      transform: 'scale(1.05)',
    },
    animation: '$slideInFromRight 0.3s ease-out',
  },
}));

export interface BuyerCopilotMoreActionsButtonProps {
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}

const BuyerCopilotMoreActionsButton: React.FC<
  BuyerCopilotMoreActionsButtonProps
> = (props: BuyerCopilotMoreActionsButtonProps) => {
  const { onClick } = props;

  const classes = useStyles();

  return (
    <Box onClick={onClick} className={classes.buttonContainer}>
      <MoreHoriz />
    </Box>
  );
};

export default BuyerCopilotMoreActionsButton;
